import React, { Component } from 'react';
import { array, shape, string } from 'prop-types';
import { connect } from 'react-redux';

import { createHighlight, resetAnnotation } from 'PipeRouter';
import HighlightOptionsViews from './views';


const keys = {
  tab:    9,
  enter:  13,
  esc:    27,
  space:  32,
  left:   37,
  up:     38,
  right:  39,
  down:   40,
  shift:  16
};

class HighlightOptions extends Component {
  componentDidMount = () => {
    const { selectedHighlight, isMobile } = this.props;

    // set the label state
    this.setState({
      label: selectedHighlight.label
    });

    // focus the SVG or input element based on the isMobile prop
    if (!isMobile && document.getElementById(selectedHighlight.markerId)) {
      const inputEl = document.getElementById(selectedHighlight.markerId);
      const svgEl = inputEl.parentElement.children[1];

      // IE11 compatibility
      svgEl.focus ? svgEl.focus() : inputEl.focus();
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.markers.length !== this.props.markers.length) {
      this.updateLabel(this.props.selectedHighlight.markerId);
    }
  };

  updateLabel = markerId => {
    const { markers } = this.props;
    const { label } = markerId;

    if (label) {
      this.setState({
        label
      });

      return;
    }

    let marker = markers.find(_marker => {
      return _marker.id === markerId;
    });

    this.setState({
      label: marker.label
    });
  };

  dispatch = event => {
    const { selectedHighlight, resetAnnotation } = this.props;
    const { keyCode, type } = event;

    switch (type) {
      case 'keyup': {
        if (keyCode === keys.esc) {
          return resetAnnotation();
        }

        const markerId = event.currentTarget.parentElement.children[0].value;

        if (keyCode === keys.tab) {
          this.updateLabel(markerId);
        }

        break;
      }
      case 'mouseenter': {
        const markerId = event.currentTarget.firstElementChild.value;
        this.updateLabel(markerId);
        break;
      }
      case 'mouseleave': {
        this.updateLabel(selectedHighlight);
        break;
      }
      default:
    }
  };

  addHighlight = () => {
    const { createHighlight, selectedHighlight } = this.props;

    createHighlight(selectedHighlight);
  }

  render() {
    const { markers, selectedHighlight } = this.props;
    const { label } = this.state;
    const viewProps = {
      addHighlight: this.addHighlight,
      dispatch: this.dispatch,
      label,
      markers,
      selectedHighlight
    };

    return <HighlightOptionsViews { ...viewProps } />;
  }
}

HighlightOptions.propTypes = {
  selectedHighlight: shape({
    color: string.isRequired,
    label: string.isRequired,
    markerId: string.isRequired,
    highlightId: string,
    noteText: string
  }),
  markers: array
};

function mapStateToProp(state) {
  const { markers, selectedHighlight, reader: { isMobile } } = state;

  return {
    markers,
    selectedHighlight,
    isMobile
  };
}


export default connect(mapStateToProp, {
  createHighlight, resetAnnotation
})(HighlightOptions);
